export default "__VITE_ASSET__DK69mLZG__"